import { render, staticRenderFns } from "./RegistrationDetailsNewCloudAccount.vue?vue&type=template&id=1a490480"
import script from "./RegistrationDetailsNewCloudAccount.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationDetailsNewCloudAccount.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports